import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatSort,
  MatDialog,
  MatPaginator
} from "@angular/material";

import { SoundEnum } from "src/app/enums/sound.enum";
import { IMajorDegree } from "src/app/interfaces/majorDegree";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { DegreeMajorEntryComponent } from "./degree-major-entry/degree-major-entry.component";
import { MajorDegreeService } from "src/app/services/http/business/majorDegree/major-degree.service";

@Component({
  selector: "app-degree-major",
  templateUrl: "./degree-major.component.html",
  styleUrls: ["./degree-major.component.css"]
})
export class DegreeMajorComponent implements OnInit {
  majorList: IMajorDegree;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ["title"];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private degreeService: MajorDegreeService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.degreeService.list().subscribe(
      res => {
        this.dataSource = new MatTableDataSource(res);
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.transaction"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    );
  }

  add(): void {
    this.dialog
      .open(DegreeMajorEntryComponent, {
        width: "350px"
      })
      .afterClosed()
      .subscribe(() => {
        this.degreeService.list(0, 0).subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }
}
